import { SUPPORTED_LOCALES } from 'locales/constants';

/**
 * Suggestions are currently persisted as localized display strings. Include every supported
 * locale so legacy values remain recognizable after a user changes the application language.
 */
export const getEvidenceSuggestionCatalog = ({ i18n, type, kind, fallbacks }) => {
    const locales = new Set(SUPPORTED_LOCALES);
    (i18n?.options?.supportedLngs || []).forEach((locale) => locales.add(locale));

    return [...locales]
        .flatMap((locale) =>
            fallbacks.map((fallback, index) => {
                const value = i18n?.getResource?.(
                    locale,
                    'assignmentSettings',
                    `evidence.types.${type}.${kind}.${index}`
                );
                return typeof value === 'string' ? value : fallback;
            })
        )
        .filter((suggestion, index, suggestions) => suggestions.indexOf(suggestion) === index);
};
